import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://7907e46b8c54ef75a52338fbabf29551@o4509134728986624.ingest.us.sentry.io/4509134730035200',
  defaultIntegrations: false,
  integrations: [
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'system',
      isNameRequired: true,
      isEmailRequired: true,
      triggerLabel: 'Reporte um erro!',
      triggerAriaLabel: 'Reporte um erro!',
      formTitle: 'Reporte um erro',
      submitButtonLabel: 'Enviar',
      cancelButtonLabel: 'Cancelar',
      formDescription: 'Nos ajude a melhorar o produto, descrevendo o erro encontrado.',
      addScreenshotButtonLabel: 'Adicionar captura de tela',
      emailLabel: 'Email',
      isRequiredLabel: 'obrigatório',
      messageLabel: 'Mensagem',
      successMessageText: 'Obrigado pelo seu feedback!',
      messagePlaceholder:
        'Descreva o erro encontrado, dê o maximo possível de descrição do seu erro',
      namePlaceholder: 'Seu Nome',
      emailPlaceholder: 'seu.email@exemplo.org',
    }),
  ],
})
